import React, { useState, useEffect, memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const CopyIcon = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
);

// Cada dispositivo recuerda si el cartel quedó achicado. Sin acceso al almacenamiento
// (modo privado, datos bloqueados) arranca abierto.
const CLAVE_OCULTO = 'alias_cuenta_oculto';

function leerOculto() {
    try {
        return window.localStorage.getItem(CLAVE_OCULTO) === '1';
    } catch (error) {
        return false;
    }
}

function guardarOculto(oculto) {
    try {
        if (oculto) window.localStorage.setItem(CLAVE_OCULTO, '1');
        else window.localStorage.removeItem(CLAVE_OCULTO);
    } catch (error) {
        // Sin almacenamiento: vale para esta visita nomás.
    }
}

// Alias de la cuenta de Mercado Pago del negocio, para que cualquier vendedor lo tenga
// a mano. Mercado Pago no lo informa: llega solo por el CVU (aliasAutomatico.js en
// functions) o lo carga un admin. Debajo va el titular del padrón de ARCA: es el nombre
// que el banco de quien paga le muestra al escribir el alias, así se confirma que está bien.
// Sale abierto; el ojito lo achica a una línea (ojo tachado) y lo vuelve a abrir (ojo
// abierto). onCambio(oculto) avisa cada toque, para el log de uso (scripts/uso.js).
const AliasCuenta = memo(({ alias, titular, onCambio }) => {
    const [copiado, setCopiado] = useState(false);
    const [oculto, setOculto] = useState(leerOculto);

    useEffect(() => {
        if (!copiado) return undefined;
        const espera = setTimeout(() => setCopiado(false), 2000);
        return () => clearTimeout(espera);
    }, [copiado]);

    const cambiarOculto = (valor) => {
        setOculto(valor);
        guardarOculto(valor);
        if (onCambio) onCambio(valor);
    };

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(alias);
            setCopiado(true);
        } catch (error) {
            // Sin permiso para el portapapeles: el alias se puede leer igual.
        }
    };

    if (oculto) {
        return (
            <div className="alias-cuenta alias-cuenta--oculto">
                <span className="alias-cuenta__titulo">Alias del negocio</span>
                <button
                    type="button"
                    className="alias-cuenta__ojo"
                    onClick={() => cambiarOculto(false)}
                    aria-label="Mostrar alias"
                    title="Mostrar alias"
                >
                    <FontAwesomeIcon icon={faEyeSlash} />
                </button>
            </div>
        );
    }

    return (
        <div className="alias-cuenta">
            <button
                type="button"
                className="alias-cuenta__ojo alias-cuenta__ojo--esquina"
                onClick={() => cambiarOculto(true)}
                aria-label="Ocultar alias"
                title="Ocultar alias"
            >
                <FontAwesomeIcon icon={faEye} />
            </button>
            <div className="alias-cuenta__titulo">Alias del negocio</div>
            <div className="alias-cuenta__valor">{alias}</div>
            {titular && (
                <div className="alias-cuenta__titular">
                    Titular: <strong>{titular}</strong>
                </div>
            )}
            <button type="button" className="alias-cuenta__copiar" onClick={copiar}>
                <CopyIcon /> {copiado ? '¡Copiado!' : 'Copiar alias'}
            </button>
        </div>
    );
});

export default AliasCuenta;
